import { useTranslation } from 'react-i18next';
import ConditionalRender from './ConditionalRender';
import { RemovePillContainer, RemovePillWrapper } from './PillButtonStyles';
import crossIcon from '@ingka/ssr-icon/paths/cross';
import Pill from '@ingka/pill';
import { PillButtonCompnentProps } from '../types/PillButtonComponent';
import { EventLoyaltyType } from '../types/model';

export const RemovePillButtonCompnent: React.FC<PillButtonCompnentProps> = ({
  filterEventState,
  updateFilter,
  resetFilter,
}): JSX.Element => {
  const { t } = useTranslation();
  const onClick = (value: string) => {
    updateFilter(value);
  };

  const pills = Object.keys(EventLoyaltyType)
    .filter((x) => {
      return x !== 'FREE_FOR_ALL_BUSINESS';
    })
    .map((pillField) => {
      const camelizeTranslationKey = (str: string) =>
        str
          .toLowerCase()
          .replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase())
          .replace(/^(\w)/g, (firstCharacter) => firstCharacter.toLowerCase());
      return {
        id: pillField,
        value: pillField,
        label: t(`event.${camelizeTranslationKey(pillField)}`),
        checked: filterEventState.includes(pillField),
        small: true,
        ssrIcon: crossIcon,
      };
    });

  return (
    <RemovePillContainer>
      {pills.map(
        (pill, index) =>
          filterEventState.includes(pill.value) && (
            <RemovePillWrapper key={index + pill.value}>
              <Pill aria-label={`${t('event.removeFilter')} ${pill.label}`} {...pill} onClick={() => onClick(pill.value)}></Pill>
            </RemovePillWrapper>
          )
      )}
      <ConditionalRender predicate={filterEventState.length > 1}>
        <RemovePillWrapper>
          <Pill
            label={t('event.clearAll')}
            aria-label={`${t('event.removeFilter')} ${t('event.clearAll')}`}
            small={true}
            ssrIcon={crossIcon}
            selected={true}
            value=""
            onClick={resetFilter}
          />
        </RemovePillWrapper>
      </ConditionalRender>
    </RemovePillContainer>
  );
};